import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'
import { OrgId } from 'app/common/types/id'

import {
  GET_SIGNATORES,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/signatories/get'

import { orgsFilterSelection } from './orgsFilter'

type Signatores = Array<ItemType>

class FAccountantSignatoresFilterDataBox extends DataBox<Signatores> {}

export const defaultFAccountantSignatores: Signatores = []
export const accountantSignatoresFilter = createDataBox(
  'accountantSignatoresFilter',
  defaultFAccountantSignatores,
  FAccountantSignatoresFilterDataBox,
)

export const defaultFAccountantSignatoresDataReceiver = async (orgsSelection?: Array<string>) => {
  const orgIds = orgsSelection || orgsFilterSelection.getData() || [null]
  const orgId = orgIds[0]
  if (!orgId) return []

  const res = await api.request(GET_SIGNATORES, {
    error: 'Не удалось получить данные бухгалтеров',
    params: {
      orgId: orgId as OrgId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res
    ? res.accountants.map(({ id, person }) => ({
        id: String(id),
        title: person.lastFirstMiddle,
      }))
    : []
}

accountantSignatoresFilter.addDataReceiver(defaultFAccountantSignatoresDataReceiver)

export const defaultFAccountantSignatoresSelection: Array<string> = []
export const accountantSignatoresFilterSelection = createDataBoxDefault<Array<string>>(
  'accountantSignatoresFilterSelection',
  defaultFAccountantSignatoresSelection,
)
